import ProfileBtn from '../btn/component-lib.esm3.js';
import ProfileLinkWrapper from '../component-lib.esm4.js';
import BtnExpand from '../shared/component-lib.esm.js';
import { useLink } from '../component-lib.esm6.js';
import { LINK_PROPS } from '../component-lib.esm3.js';
import LoadingBlock from '../../components/loading-block/component-lib.esm.js';
import ChevronIcon from '../../icons/arrows/component-lib.esm2.js';

//
var script = {
  components: {
    ProfileBtn,
    ProfileEmbedContainer: () => ({
      component: import('../embed/component-lib.esm3.js').then(d => d.default),
      loading: LoadingBlock
    }),
    LockedExpandPanel: () => ({
      component: import('../shared/locked/component-lib.esm.js').then(d => d.default),
      loading: LoadingBlock
    }),
    BtnExpand,
    ProfileLinkWrapper,
    ChevronIcon,
    LockOIcon: () => import('../../icons/component-lib.esm42.js').then(d => d.default),
    LockOOpenIcon: () => import('../../icons/component-lib.esm31.js').then(d => d.default)
  },
  props: LINK_PROPS,
  setup(props, context) {
    const {
      id,
      imageUrl,
      linkUrl,
      isLocked,
      lockMeta,
      hasBeenUnlocked,
      showLockedTemplate,
      isEmbedLink,
      embedOptions,
      embedId,
      expand,
      isOpen,
      handleClick,
      handleUnlock,
      setHighlight,
      btnProps
    } = useLink(props, context);
    return {
      id,
      expand,
      isOpen,
      isEmbedLink,
      embedId,
      embedOptions,
      handleClick,
      imageUrl,
      linkUrl,
      btnProps,
      setHighlight,
      isLocked,
      lockMeta,
      hasBeenUnlocked,
      showLockedTemplate,
      handleUnlock
    };
  }
};
export { script as default };